import DataListPage from "./dataListPage";

export default DataListPage;
